export default "//file.bilionpass.com/japandx-portal/0.1.15/static/img/page-arrow-right.9e1594b5-0c8750.svg";